import script from "./orderlyCharg.vue?vue&type=script&setup=true&lang=js"
export * from "./orderlyCharg.vue?vue&type=script&setup=true&lang=js"

import "./orderlyCharg.vue?vue&type=style&index=0&id=304728a5&lang=scss"

const __exports__ = script;

export default __exports__